
export default {
  name: "DrawerHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    btnText: {
      type: String,
      default: function () {
        return this.$t("cart.save")
      }
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    btnDisabled: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: "rtl"
    }
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit("close")
    },
    handleSubmit() {
      if (this.btnDisabled) return

      this.$emit("submit")
    }
  }
}
